import { faChevronDown, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from '@mui/material';
import { ReactNode, useState } from 'react';

import './styles.scss';

interface CollapsibleSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

export const CollapsibleSection = ({
  title,
  defaultOpen = true,
  children,
}: CollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="collapsible-section">
      <div className="collapsible-section-header" onClick={() => setIsOpen((prev) => !prev)}>
        <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} className="chevron-icon" />
        <span className="collapsible-section-title">{title}</span>
      </div>
      <Collapse in={isOpen}>
        <div className="collapsible-section-content">{children}</div>
      </Collapse>
    </div>
  );
};
